import 'babel-polyfill';
import 'slick-carousel';

import { binder } from './libs/binder';
import { constants } from './modules/module';
// import createSponsorSlider from './modules/sponsorSlider';
import createReviewSlider from './modules/reviewSlider';
import { openResponsiveMenu } from './modules/headerMenu';
import createTab from './modules/tab';
import createAccordion from './modules/accordion';
import { hideContent, showContent } from './modules/showMore';
import { openFilter, closeFilter } from './modules/asideFilter';
import { checkAll, clearQueryParams } from './modules/formControl';
import { controlAnchors, trackArchorTarget } from './modules/anchors';
import scrollToFix from './modules/scrollToFix';
import coursesBuy from './modules/coursesBuy';
import scrollLink from './modules/anchorLink';
import courseContent from './modules/courseContent';
import coursesFilters from './modules/coursesFilters';
import courseCard from './modules/courseCard';

binder({
  bounds: {
    html: [constants, scrollLink],
    '.header': openResponsiveMenu,
    // '.sponsor-slider': createSponsorSlider,
    '.tab': createTab,
    '.accordion': createAccordion,
    '.review-slider': createReviewSlider,
    '.show-more-content': [hideContent, showContent],
    '.form-filter': [openFilter, closeFilter, checkAll, clearQueryParams],
    '.has-anchor': controlAnchors,
    '.scroll-fix': scrollToFix,
    '.archon-target': trackArchorTarget,
    '.section-calculator': coursesBuy,
    '.section-course-content': courseContent,
    '.all-courses-list': coursesFilters,
    '.courses-grid': courseCard,
  },
  runTests: false,
});



// WEBPACK FOOTER //
// ./assets/js/global.js